import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { getGlobalClasses } from '../../themes';

import AuthUserContainer from '../../containers/AuthUser';
import { post } from '../../modules/utility';
import { PureRecordRow, sortTable } from '../../libs/tableUtilities';
import Table from '@material-ui/core/Table';
import EnhancedTableHead from '../../components/table/EnhancedTableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import CheckIcon from '@material-ui/icons/Check';
import BlockIcon from '@material-ui/icons/Block';

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		contentTitle: {
			display: 'flex',
			alignItems: 'center',
			fontSize: 24,
			borderBottom: '1px solid #ddd',
			paddingBottom: 15,
			marginBottom: 15,
		},
		totalHours: {
			padding: 20,
			backgroundColor: '#F1F8F8',
			border: `1px solid #abc4d4`,
			fontSize: '18px',
			fontWeight: 500,
			marginBottom: 10,
		},
	};
};

function getPayPeriods() {
	const payPeriods = [];
	const startOfPayPeriod = moment('2021-04-12').startOf('day');
	// const startOfPayPeriod = moment("2021-03-29").startOf("day");
	let count = 0;
	while (count++ < 199) {
		payPeriods.push({
			start: moment(startOfPayPeriod),
			end: moment(startOfPayPeriod).add(13, 'days').endOf('day'),
		});
		startOfPayPeriod.add(14, 'days');
	}

	let last = undefined;
	let current = undefined;

	let i = 0;
	const now = moment();
	while (current === undefined) {
		const { start, end } = payPeriods[i];
		if (now.isAfter(start) && now.isBefore(end)) {
			current = payPeriods[i];
			if (i) {
				last = payPeriods[i - 1];
			}
		}
		i++;
	}

	console.log(current, last);
	return { currentPayPeriod: current, lastPayPeriod: last };
}

class RecentShifts extends Component {
	constructor(props) {
		super(props);

		const { currentPayPeriod, lastPayPeriod } = getPayPeriods();

		this.state = {
			order: 'desc',
			orderBy: 'clockInDateTime',
			lastPunchInfoResults: undefined,
			showClockInSuccessful: false,
			showClockOutSuccessful: false,
			currentPayPeriodResults: undefined,
			lastPayPeriodResults: undefined,
			currentPayPeriod,
			lastPayPeriod,
		};
	}

	componentDidMount() {
		this.getShiftAnalysis({ callback: _.noop });
		this.getCurrentPayPeriodShifts({ callback: _.noop });
		if (this.state.lastPayPeriod) {
			this.getLastPayPeriodShifts({ callback: _.noop });
		}
	}

	getShiftAnalysis = ({ callback }) => {
		const { showErrors } = this.props;
		post({
			method: 'timeClockShift.user.getShiftAnalysis',
			params: {},
			callback: (err, r) => {
				if (err) {
					showErrors(err);
					return callback(err);
				}

				const timeClockAnalysisResult = _.get(r, 'timeClockAnalysisResults.0', {});
				this.setState({
					timeClockAnalysisResult,
				});
				callback(null, { timeClockAnalysisResult });
			},
		});
	};

	getCurrentPayPeriodShifts = () => {
		const { showErrors } = this.props;

		const { currentPayPeriod } = this.state;
		const { start, end } = currentPayPeriod;
		post({
			method: 'timeClockShift.user.search',
			params: {
				afterDateTime: moment(start).utc().format('YYYY-MM-DD HH:mm:ss'),
				beforeDateTime: moment(end).utc().format('YYYY-MM-DD HH:mm:ss'),
			},
			callback: (err, r) => {
				if (err) {
					return showErrors(err);
				}

				this.formatSearchResults(r, 'currentPayPeriodResults');
			},
		});
	};

	getLastPayPeriodShifts = () => {
		const { showErrors } = this.props;

		const { lastPayPeriod } = this.state;
		const { start, end } = lastPayPeriod;
		post({
			method: 'timeClockShift.user.search',
			params: {
				afterDateTime: moment(start).utc().format('YYYY-MM-DD HH:mm:ss'),
				beforeDateTime: moment(end).utc().format('YYYY-MM-DD HH:mm:ss'),
			},
			callback: (err, r) => {
				if (err) {
					return showErrors(err);
				}

				this.formatSearchResults(r, 'lastPayPeriodResults');
			},
		});
	};

	handleSort = (orderBy) => {
		let order = 'desc';
		if (this.state.orderBy === orderBy && this.state.order === 'desc') {
			order = 'asc';
		}
		this.setState({ order: order, orderBy: orderBy });
	};

	render = () => {
		const { classes } = this.props;
		const { lastPayPeriodResults, currentPayPeriodResults } = this.state;

		if (_.isUndefined(currentPayPeriodResults)) {
			return <div className={classes.globalFetching}>Fetching recent shifts...</div>;
		}

		const columns = [
			{
				id: 'Employee',
				label: 'Employee',
			},
			{
				id: 'clockInDateTime',
				label: 'Clock In',
			},
			{
				id: 'clockOutDateTime',
				label: 'Clock Out',
			},
			{
				id: 'durationDiff',
				label: 'Duration',
			},
			{
				id: 'details',
				label: 'Details',
			},
			{
				id: 'hasBeenExportedDisplay',
				labels: ['Exported', 'to Exponent'],
			},
		];

		const { lastPayPeriod, currentPayPeriod } = this.state;
		return (
			<Fragment>
				{this.renderPayPeriodTable({
					columns,
					formattedResults: currentPayPeriodResults,
					title: 'Current Pay Period',
					payPeriod: currentPayPeriod,
				})}

				{!!lastPayPeriodResults &&
					this.renderPayPeriodTable({
						columns,
						formattedResults: lastPayPeriodResults,
						title: 'Previous Pay Period',
						payPeriod: lastPayPeriod,
					})}
			</Fragment>
		);
	};

	renderPayPeriodTable = ({ columns, formattedResults, title, payPeriod }) => {
		const { classes } = this.props;
		const { order, orderBy } = this.state;

		if (_.isUndefined(formattedResults)) {
			return <div className={classes.globalFetching}>Fetching shifts...</div>;
		}
		const { timeClockShiftRows, totalDurationDisplay } = formattedResults;

		const rows = sortTable({
			rows: timeClockShiftRows,
			order,
			orderBy,
		});

		const managerEventToDisplay = {
			managerClockIn: 'clocked in employee',
			managerClockOut: 'clocked out employee',
			managerUpdate: 'changed employee shift',
			managerAdd: 'added employee shift',
		};

		const { start, end } = payPeriod;
		const range = `${start.format('ddd M/D')} - ${end.format('ddd M/D')}`;

		return (
			<Paper className={classes.globalMainPaper}>
				<div className={classes.contentTitle}>
					<div className={classes.timeClockIcon} />
					<div>
						{title} ({range})
					</div>
				</div>
				<div className={classes.totalHours}>
					Total Hours for {title}: <strong>{totalDurationDisplay}</strong>
				</div>

				<Table size="small" className={classes.table}>
					<EnhancedTableHead
						columns={columns}
						order={order}
						orderBy={orderBy}
						onRequestSort={this.handleSort}
					/>
					<TableBody>
						{rows.map((row) => {
							return (
								<PureRecordRow hover key={row.timeClockShiftId} refreshId={this.state.refreshId}>
									<TableCell>{row.userDisplay}</TableCell>
									<TableCell>{row.clockInDateTimeDisplay}</TableCell>
									<TableCell>{row.clockOutDateTimeDisplay}</TableCell>
									<TableCell>{row.durationDisplay}</TableCell>
									<TableCell>
										{row.timeClockShiftEvents.map((timeClockShiftEvent) => {
											const {
												timeClockShiftEventId,
												user,
												eventType,
												note,
												dateCreatedFormatted,
											} = timeClockShiftEvent;

											if (eventType === 'userClockIn' || eventType === 'userClockOut') {
												const verb = eventType === 'userClockIn' ? 'clocked in' : 'clocked out';
												return (
													<div key={timeClockShiftEventId} className={classes.eventContainer}>
														<div style={{ whiteSpace: 'pre-line' }}>
															{user.firstName} {user.lastName} {verb}
														</div>
													</div>
												);
											} else {
												const verb = managerEventToDisplay[eventType] || 'performed unknown action';
												return (
													<div key={timeClockShiftEventId} className={classes.eventContainer}>
														<div style={{ whiteSpace: 'pre-line' }}>
															<strong>
																{user.firstName} {user.lastName}
															</strong>{' '}
															{verb}
														</div>
														<div className={classes.eventNote}>Reason : {note}</div>
														<div className={classes.eventDateTime}>{dateCreatedFormatted}</div>
													</div>
												);
											}
										})}
									</TableCell>
									<TableCell>{row.hasBeenExportedDisplay}</TableCell>
								</PureRecordRow>
							);
						})}
					</TableBody>
				</Table>
			</Paper>
		);
	};
	formatSearchResults = (apiResult, prefix) => {
		const c = _.get(apiResult, 'collections');
		const timeClockShifts = _.get(c, 'timeClockShiftCollection', []);
		const userMap = _.keyBy(_.get(c, 'userCollection', []), 'userId');

		let totalDurationDiff = 0;

		const now = moment();
		const timeClockShiftRows = timeClockShifts.map((timeClockShift) => {
			const {
				timeClockShiftId,
				clockInDateTime,
				clockOutDateTime,
				shiftForUserId,
				timeClockShiftEvents,
				exportedInExponentFtpRecordId,
				doNotExport,
			} = timeClockShift;

			const user = userMap[shiftForUserId] || {
				firstName: 'Missing',
				lastName: '',
			};
			const userDisplay = `${user.firstName} ${user.lastName}`;
			const clockInMoment = moment(clockInDateTime);
			const clockInDateTimeDisplay = clockInMoment.format('ddd M/D h:mm a');
			const hasClockOut = clockOutDateTime;

			let durationDiff = now.diff(clockInMoment);
			let clockOutDateTimeDisplay = 'Currently Clocked in';
			if (hasClockOut) {
				const clockOutMoment = moment(clockOutDateTime);
				clockOutDateTimeDisplay = clockOutMoment.format('ddd M/D h:mm a');
				durationDiff = clockOutMoment.diff(clockInMoment);
			}
			totalDurationDiff += durationDiff;
			let durationDisplay = moment.duration(durationDiff).format('h [hrs], m [min]');

			timeClockShiftEvents.forEach((timeClockShiftEvent) => {
				const { createdByUserId, dateCreated } = timeClockShiftEvent;
				timeClockShiftEvent.user = userMap[createdByUserId] || {
					firstName: 'Missing',
					lastName: '',
				};
				timeClockShiftEvent.dateCreatedFormatted = moment(dateCreated).format('M/D h:mm a');
			});

			return {
				timeClockShiftId,
				clockInDateTime,
				clockInDateTimeDisplay,
				clockOutDateTime,
				clockOutDateTimeDisplay,
				durationDiff,
				durationDisplay,
				shiftForUserId,
				userDisplay,
				hasClockOut,
				timeClockShiftEvents,
				hasBeenExportedDisplay: exportedInExponentFtpRecordId ? (
					<CheckIcon />
				) : doNotExport ? (
					<BlockIcon />
				) : (
					''
				),
				exportedInExponentFtpRecordId,
			};
		});

		let totalDurationDisplay = moment.duration(totalDurationDiff).format('h [hrs], m [min]');

		this.setState({
			[prefix]: {
				timeClockShiftRows,
				totalDurationDisplay,
			},
			savingStatus: 'done',
			refreshId: this.state.refreshId + 1,
		});
	};
}

RecentShifts.propTypes = {
	authUser: PropTypes.object,
};

export default _.flow([withStyles(styles), AuthUserContainer])(RecentShifts);
